var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-post',{ref:"formPost",attrs:{"params":_vm.params,"route":"/admin/site-admin-session"}})}
var staticRenderFns = []

export { render, staticRenderFns }